import Spinner from '../commons/spinner/Spinner';
import classesNames from './pageLoader.module.scss';

export default function Loader() {
  return (
    <div className={classesNames.LoaderOverlay}>
      <div className={classesNames.Loader}>
        <Spinner color="#ffffff" size={72} />
        <p className={classesNames.LoadingText}>جاري التحميل</p>
      </div>
    </div>
  );
}
